import { ApplicationError } from '@office-start/application-error';
import { DataSecurityLevel, } from '@office-start/instrumentation-types';
import { filterPii } from '@office-start/privacy-utility';
import { drainQueue, queueEvent } from './EventQueue';
import { replaceConditionalParams } from './utilities/replaceConditionalParams';
var registeredEventSinks = [];
var eventsRestricted = false;
var applyGlobalStateParams;
var appSecurityLevel = DataSecurityLevel.Full;
function recordEvent(streamName, securityThreshold, params, metrics) {
    var isErrorEvent = params &&
        ((params["EventName" /* EventName */] &&
            params["EventName" /* EventName */].indexOf('Error') > -1) ||
            (params["Error" /* Error */] &&
                params["Error" /* Error */] !== 'OK'));
    if (appSecurityLevel < securityThreshold ||
        (eventsRestricted && !isErrorEvent)) {
        return;
    }
    replaceConditionalParams(params, appSecurityLevel);
    var error = params && params["Error" /* Error */];
    if (error && typeof error === 'string') {
        // Some Global errors contain email addresses since they log the full page url, which can include a 'username' query param.
        // Redacting all emails here.
        params["Error" /* Error */] = filterPii(error);
    }
    var debugInfo = params && params["DebugInfo" /* DebugInfo */];
    if (debugInfo && typeof debugInfo === 'string') {
        params["DebugInfo" /* DebugInfo */] = filterPii(debugInfo);
    }
    if (registeredEventSinks.length > 0) {
        registeredEventSinks.forEach(function (sink) {
            sink.logEvent(streamName, params, metrics);
        });
    }
    else {
        var queuedEvent = {
            streamName: streamName,
            eventName: params["EventName" /* EventName */],
            eventParams: params,
            metrics: metrics,
            securityThreshold: securityThreshold,
        };
        queueEvent(queuedEvent);
    }
}
// TODO: Add tests for event generation/logging
export function generateEvent(eventName, streamName, securityThreshold, params, metrics, record) {
    if (params === void 0) { params = {}; }
    if (metrics === void 0) { metrics = []; }
    if (record === void 0) { record = false; }
    params["EventName" /* EventName */] = eventName;
    applyGlobalStateParams && applyGlobalStateParams(params, streamName);
    var event = {
        params: params,
        metrics: metrics,
        record: function () {
            return recordEvent(streamName, securityThreshold, params, metrics);
        },
    };
    if (record) {
        event.record();
    }
    return event;
}
function drainQueuedEvents() {
    var queuedEvents = drainQueue();
    queuedEvents.forEach(function (event) {
        generateEvent(event.eventName, event.streamName, event.securityThreshold, event.eventParams || {}, event.metrics, true);
    });
}
// TODO: Add tests for initialization
export function initializeInstrumentation(sinks, applyGlobalStateCallback, initialAppSecurityLevel, restrictEvents) {
    if (restrictEvents === void 0) { restrictEvents = false; }
    if (registeredEventSinks.length > 0) {
        throw new ApplicationError('initializeInstrumentationService is not allowed to be called more than once');
    }
    if (!sinks || sinks.length === 0) {
        throw new ApplicationError('Must specify at least one event factory when calling initializeInstrumentation');
    }
    // Make a copy of the passed array
    registeredEventSinks = sinks.slice();
    applyGlobalStateParams = applyGlobalStateCallback;
    if (typeof initialAppSecurityLevel === 'number') {
        appSecurityLevel = initialAppSecurityLevel;
    }
    eventsRestricted = restrictEvents;
    // Drain queued events for all apps
    drainQueuedEvents();
}
// TODO: Add tests for flush and updateappsecuritylevel
export function flush() {
    drainQueuedEvents();
    registeredEventSinks.forEach(function (sink) {
        sink.flush();
    });
}
export function getAppSecurityLevel() {
    return appSecurityLevel;
}
export function updateAppSecurityLevel(level) {
    appSecurityLevel = level;
}
//# sourceMappingURL=InstrumentationService.js.map